module.exports = __webpack_public_path__ + "static/img/img02.972b315.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mb/mb052/img02.jpg
// module id = G+5m
// module chunks = 0